// extracted by mini-css-extract-plugin
export default {"root":"_2pxTK","image":"_2jSgr","large":"_3AWmi","medium":"_siOK","small":"_3zwfQ"};